<template>
	<j-box class="flex wrap margin-center xs-12 xs-center">
		<j-box class="xs-12 ta2 fs8 mt15 mb2 fw7 cError lh125">
			{{ $t("ooops") }}
		</j-box>
		<j-box class="xs-12 c1 r1 ta2 lh125">
			{{ this.$t("errors.this_url_no_longer_exists") }}
		</j-box>
		<j-box class="flex xs-12 xs-center xs-middle mt6">
			<j-button type="primary" @click="refresh">{{
				this.$t("errors.try_again")
			}}</j-button>
		</j-box>
	</j-box>
</template>

<script>
import JBox from "@/components/JBox"
import JButton from "@/components/JButton"

export default {
	name: "page-error",
	components: { JBox, JButton },
	methods: {
		refresh() {
			window.TK = null
			window.location = window.location
		}
	}
}
</script>
